import {detectBrowser} from "./DetectBrowser";

export function clientInfo(){
    return {
        browser : detectBrowser(),
        language : window.navigator.language,
        os: window.navigator.platform,
        userAgent : window.navigator.userAgent
    }
}